<template>
  <div v-loading="loading" class="GmzAndYszxx">
    <div class="_title">
      <p class="_title_info">购买证及运输证相关信息</p>
    </div>
    <div>
      <el-form
        ref="searchForm"
        label-position="right"
        label-width="200px"
        class="formClass"
      >
        <el-form-item label="购买证编号：" prop="xkzBh">
          <el-input v-model="xkzBh" />
        </el-form-item>
      </el-form>
      <div class="buttonList">
        <el-button @click="reset"> 重 置 </el-button>
        <el-button type="primary" @click="searchSubmit"> 搜 索 </el-button>
      </div>
    </div>
    <div v-if="!dataExist" style="height: 500px">
      <div style="text-align: center;margin-top: 150px;margin-bottom: 100px;color: #27660dbf;font-size: 30px;">请输入要查询的购买证编号</div>
    </div>
    <div v-else>
      <div style="height: 470px;">
        <div style="width: 48%; float: left;">
          <el-row :gutter="24">
            <el-col :span="24">
              <el-card shadow="never">
                <div style="display: inline-block;">
                  <div>
                    <div class="demo-image__preview" style="height: 410px;text-align: center;overflow-y:auto">
                      <el-image
                        style="width: 100%"
                        :src="getPicUrl(gmzPic,xkzBh)"
                        :preview-src-list="getPicUrlArr(gmzPic,xkzBh)"></el-image>
                    </div>
                  </div>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </div>
        <div style=" display: inline-block;width: 35%;padding-left: 20px">
          <el-descriptions title="购买证基本信息" :column="1" border >
            <el-descriptions-item labelStyle="width:110px" >
              <template slot="label">
                购买证编号
              </template>
              {{record.xkzBh}}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                化学品名称
              </template>
              {{record.hxpMc}}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                购买单位
              </template>
              {{record.gmdwMc}}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                销售单位
              </template>
              {{record.xsdwMc}}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                购买证数量
              </template>
              {{record.hzsl+'('+record.hzslDwLabel+')'}}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                购买入库总量
              </template>
              {{record.gmrkZl+'('+record.hzslDwLabel+')'}}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                销售出库总量
              </template>
              {{record.xsckZL+'('+record.hzslDwLabel+')'}}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                核发日期
              </template>
              {{record.hfrq}}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                状态
              </template>
              {{record.ztLabel}}
            </el-descriptions-item>
          </el-descriptions>
        </div>
      </div>
      <div>
        <span style="font-size: 16px;font-weight: 700;">购买运输证</span>
        <div class="tablemes" style="margin-top:20px;">
          <el-table
            ref="yszTabel"
            :data="gmYszList"
            border
            :show-overflow-tooltip="true"
            :header-cell-style="{ background: '#F2F2F2' }"
            style="width: 100%"
          >
            <el-table-column
              prop="xkzBh"
              label="运输证编号"
            />
            <el-table-column
              prop="hxpMc"
              label="化学品"
            />
            <el-table-column
              prop="shdwMc"
              label="收货单位(购买方)"
            />
            <el-table-column
              prop="fhdwMc"
              label="发货单位(销售方)"
            />
            <el-table-column
              label="运输证数量"
            >
              <template slot-scope="scope">
                {{scope.row["hzsl"] +
                "  (" +
                scope.row["hzslDwLabel"] +
                ")"}}
              </template>
            </el-table-column>
            <el-table-column
              label="报备总量"
            >
              <template slot-scope="scope">
                {{scope.row["ysbbZl"] +
                "  (" +
                scope.row["hzslDwLabel"] +
                ")"}}
              </template>
            </el-table-column>
            <el-table-column
              prop="hfrq"
              label="核发日期"
            />
            <el-table-column
              prop="ztLabel"
              label="状态"
            />
            <el-table-column label="操作" align="center" width="200px">
              <template slot-scope="scope">
                <el-button
                  v-preventReClick
                  type="primary"
                  icon="el-icon-document"
                  size="mini"
                  @click="getYszImg(scope.$index, scope.row)"
                >查看证件</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div style="margin-top:20px;">
        <span style="font-size: 16px;font-weight: 700;">退货运输证</span>
        <div class="tablemes" style="margin-top:20px;">
          <el-table
            ref="yszTabel"
            :data="thYszList"
            border
            :show-overflow-tooltip="true"
            :header-cell-style="{ background: '#F2F2F2' }"
            style="width: 100%"
          >
            <el-table-column
              prop="xkzBh"
              label="运输证编号"
            />
            <el-table-column
              prop="hxpMc"
              label="化学品"
            />
            <el-table-column
              prop="fhdwMc"
              label="发货单位(购买方)"
            />
            <el-table-column
              prop="shdwMc"
              label="收货单位(销售方)"
            />
            <el-table-column
              label="运输证数量"
            >
              <template slot-scope="scope">
                {{scope.row["hzsl"] +
                "  (" +
                scope.row["hzslDwLabel"] +
                ")"}}
              </template>
            </el-table-column>
            <el-table-column
              label="报备总量"
            >
              <template slot-scope="scope">
                {{scope.row["ysbbZl"] +
                "  (" +
                scope.row["hzslDwLabel"] +
                ")"}}
              </template>
            </el-table-column>
            <el-table-column
              prop="hfrq"
              label="核发日期"
            />
            <el-table-column
              prop="ztLabel"
              label="状态"
            />
            <el-table-column label="操作" align="center" width="200px">
              <template slot-scope="scope">
                <el-button
                  v-preventReClick
                  type="primary"
                  icon="el-icon-document"
                  size="mini"
                  @click="getYszImg(scope.$index, scope.row)"
                >查看证件</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <el-dialog :title="'运输证'+yszBh" :visible.sync="showYszImg" >
      <div>
        <el-image
          style="width: 100%; height: auto"
          :src="getPicUrl(yszurl,yszBh)"
          :preview-src-list="getPicUrlArr(yszurl,yszBh)"></el-image>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {getGmzAndYszxx} from "@/assets/js/system";
  import {returnShowPicByPdf} from "@/assets/js/common";
  import {isEmpty} from "@/utils/tool";
  export default {
    name: 'GmzAndYszxx',
    data() {
      return {
        xkzBh:'',
        yszBh: '',
        showYszImg:false, //运输证图片
        yszurl: '',
        dataExist: false,
        loading: false,
        record: {},
        gmzPic:'none_data.jpg', //默认图片
        gmYszList: [],
        thYszList: [],
      }
    },
    mounted(){
    },
    methods: {
      reset(){
        this.xkzBh = ''
        this.dataExist = false
      },
      searchSubmit(){
        this.loading = true
        this.cshYwsj()
        if(!isEmpty(this.xkzBh)){
          getGmzAndYszxx({xkzBh: this.xkzBh}).then((e) => {
            let res = e.data
            if(res.code == '000000'){
              this.dataExist = true;
              this.record = res.data
              this.gmzPic = isEmpty(res.data.imgNoYz)?'none_data.jpg':res.data.imgNoYz
              this.gmYszList = res.data.gmysList
              this.thYszList = res.data.thysList

            }else{
              this.dataExist = false
            }
            this.loading = false
          }).catch((e)=>{
            this.dataExist = false
            this.loading = false
          })
        }else{
          this.$message.warning("请输入购买证编号")
          this.loading = false
        }
      },
      cshYwsj(){ //数据初始化
        this.record = {}
        this.gmzPic = 'none_data.jpg'
        this.gmYszList = []
        this.thYszList = []
        this.showYszImg = false
      },
      getPicUrl(picUrl,xkzBh){
        if(picUrl == 'none_data.jpg'){
          return require('@/assets/img/none_data.jpg')
        }else{
          // return returnShowPic()+picUrl
          return returnShowPicByPdf(xkzBh)
        }
      },
      getPicUrlArr(picUrl,xkzBh){
        let picArr = []
        if(picUrl == 'none_data.jpg'){
          picArr.push(require('@/assets/img/none_data.jpg'))
        }else{
          // picArr.push(returnShowPic()+picUrl)
          picArr.push(returnShowPicByPdf(xkzBh))
        }
        return picArr
      },
      getYszImg(index,row){
        this.yszurl = ''
        this.yszBh = ''
        if(isEmpty(row.imgNoYz)){
          this.$message.warning('该运输证没有打印的图片!')
        }else{
          this.showYszImg = true
          this.yszBh = row.xkzBh
          this.yszurl = row.imgNoYz
        }

      }
    }
  }
</script>

<style lang='less' scoped>
  .GmzAndYszxx {
    overflow-y: auto;
    padding: 20px;
    background-color: white;
    margin: 10px;
    ._title {
      margin-top: 20px;
      width: 100%;
      ._title_info {
        text-align: center;
        font-size: 23px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #434343;
        line-height: 15px;
        height: 15px;
        font-family: Helvetica;
      }
    }
    .formClass{
      width: 35%;
      margin-right: 20px;
      display: inline-block;
    }
    .buttonList {
      display: inline-block;
      flex-wrap: wrap;
      justify-content: space-between;
      margin: 40px auto 0px auto;
      width: 50%;
    }

    .small_img{
      width: 114px;
      height: 114px;
    }

    .date_input{
      width: 31%;
    }

    /deep/ .el-dialog .el-dialog__body {
      height: 650px !important;
      overflow-y: auto !important;
    }
  }
</style>
